<template>
    <tasks :project-id="$route.params.slug" />
</template>

<script>
    import Tasks from '../../../components/Tasks.vue'
    import { mapActions } from 'vuex'

    export default {
        components: {
            Tasks
        },

        mounted () {
            this.fetchTasks({project_id: this.$route.params.slug})
        },

        methods: {
            ...mapActions({
                fetchTasks: 'fetchTasks'
            })
        }
    }
</script>
